import Vue from 'vue'
import Vuex from 'vuex'
import { getUrlVars } from '../util/getUrlVars';
import loginUtil from '../util/autoLogin';
import { getBasicMaterialList } from '../util/requests'

import { updateShopCarWithParams, processingBasicMaterialFilter ,updateColorShopCarWithParams } from '../util/processingData'

// require('../util/vuex-axios-api.js')
Vue.use(Vuex)

export function generateStore(request) {
  return new Vuex.Store({
    state: {
      userInfo: {},
      fromClient:false,//被客户端集成，控制部分显隐
      noFooter:false,//控制footer是否出现
      backendNav:false,//控制导航为后台导航还是正常导航
      navNow:"云仓商城",//控制app当前页面
      supplierInfo:"",//为null表示不是供应商
      storageInfo:null,//为null表示不是云仓
      shopCarInfo: {}, //key为uid，value是一个对象，包含phone,customerName, remark, address, items四个字段
      basicMaterialFilter: [],
      classFilter: [],
      colorMallInfo: {}, //同shopCarInfo
      classifyArr: [], // 导航栏分类
      userDfv:'',
      identityMode:0,  //0总账号
      mainAcounts:[],//主账号列表
      saveMyUserInfo:'', //切换员工模式用户保存自己的用户信息
      saveMySupplierInfo:'', //切换员工模式用户保存自己的供应商信息
      hbImportShow:true,
    },
    getters:{
      mode(state){//0:老板良；1：guiguiERP
        if(state.saveMySupplierInfo){
          return 0
        }else{
          return 1
        }
      },
      staffInfo(state){
        if(state.identityMode){
          return state.mainAcounts.filter(item => {
            if(item.uid == state.userInfo.id){
              return item
            }
          })[0]
        }else{
          return 0
        }
      }
    },
    mutations: {
      sethbImportShow(state,value){
        state.hbImportShow = value
      },
      // 画册商城加入购物车
      initColorShopCar(state) {
        let shopCar = window.localStorage.getItem('colorMallInfo');
        if (shopCar) {
          shopCar = JSON.parse(shopCar);
          state.colorMallInfo = shopCar;
        }
      },
      setColorShopCar(state, payload) {
        // mode 是本次购物车修改模式，'add'为追加， 'update'为修改原订单
        const { shopCarInfo, mode } = payload;
        const { uid, supplierId } = shopCarInfo;
        let shopCar = window.localStorage.getItem('colorMallInfo');
        if (shopCar) {
          shopCar = JSON.parse(shopCar);
        }
        const initialValue = {
          address: state.userInfo.address,
          phone: state.userInfo.phone,
          customerName: state.userInfo.name,
          remark: '',
          items: []
        };

        if (!shopCar) {
          shopCar = {
            [uid]: {
              [supplierId]: initialValue
            }
          }
        } else if (!shopCar[uid]) {
          shopCar[uid] = {
            [supplierId]: initialValue
          }
        } else if (!shopCar[uid][supplierId]) {
          shopCar[uid][supplierId] = initialValue
        }
        shopCar[uid][supplierId] = updateColorShopCarWithParams(shopCarInfo, { ...shopCar[uid][supplierId] }, mode);
        window.localStorage.setItem('colorMallInfo', JSON.stringify(shopCar));

        state.shopCarInfo = shopCar;
      },
      initShopCar(state) {
        let shopCar = window.localStorage.getItem('shopCarInfo');
        if (shopCar) {
          shopCar = JSON.parse(shopCar);
          state.shopCarInfo = shopCar;
        }
      },

      setShopCar(state, payload) {
        // mode 是本次购物车修改模式，'add'为追加， 'update'为修改原订单
        const { shopCarInfo, mode } = payload;
        // console.log('in setShopCar: ',shopCarInfo);
        const { uid, supplierId } = shopCarInfo;
        let shopCar = window.localStorage.getItem('shopCarInfo');
        // console.log('aaaaaa',shopCar)
        
        if (shopCar) {
          shopCar = JSON.parse(shopCar);
        }
        // console.log('11111111',shopCar)
        const initialValue = {
          address: state.userInfo.address,
          phone: state.userInfo.phone,
          customerName: state.userInfo.name,
          remark: '',
          items: []
        };
        if (!shopCar) {
          shopCar = {
            [uid]: []
          }
        } else if (!shopCar[uid]) {
          shopCar[uid] = []
        }
        shopCarInfo.items.forEach((good) => {
          const goodsId = good.id;
          const index = shopCar[uid].findIndex((item) => {
            return item.id == goodsId;
          });
          // console.log('good',good)
          // console.log('shopCarInftems',shopCarInfo.items)
          if (index == -1) {
            // good.num = good.num;
            shopCar[uid].push(good);
          } else {
            shopCar[uid][index].num += Number(good.num);
          }
        })
        // shopCar[uid] = updateShopCarWithParams(shopCarInfo, { ...shopCar[uid][supplierId] }, mode,state.userInfo.cloud_vip);
        console.log('shopCar',shopCar)
        window.localStorage.setItem('shopCarInfo', JSON.stringify(shopCar));

        state.shopCarInfo = shopCar;
      },
      setUserInfo (state, payload) {
        window.localStorage.setItem('data', JSON.stringify(payload));
        state.userInfo = payload;
        state.saveMyUserInfo = payload
      },
      changeNavNow(state,now){
        state.navNow=now
      },
      changeNoFooter(state,bool){
        state.noFooter=bool
      },
      changeBackendNav(state,bool){
        state.backendNav=bool
      },
      setFromClient(state,bool){
        state.fromClient=bool
      },
      setSupplierInfo(state,payload){
        state.supplierInfo = payload;
      },
      setUserDfv(state,value){
        state.userDfv = value
      },
      setIdentity(state,value){
        state.identityMode = value
      },
      setMainAcounts(state,value){
        state.setMainAcounts = value
      },
      changeMainAcountInfo(state,value){
        if(value){
          state.userInfo = value
          // 保存当前选中身份状态
          let saveMainAcountInfo = {
            identityMode:state.identityMode,
            staffUserInfo:state.userInfo,
          }
          sessionStorage.setItem('saveMainAcountInfo',JSON.stringify(saveMainAcountInfo))
        }else{
          state.userInfo = JSON.parse(localStorage.data)
          sessionStorage.removeItem('saveMainAcountInfo')
        }
      },
      async changeSupplierInfo(state,value){
        request.getSupplierInfo({
          uid:value
        }).then(res => {
          state.supplierInfo=res
        })
        state.supplierInfo = value
      },
      async initUserInfo (state) {
        // 先从url中的参数中获取登录信息
        // 没有url参数时，再从localStorage中取登录信息
        // 均不存在登录信息时，则为未登录状态

        // window.location.search只能获取到?和#之间的内容，这里处理获取不到登录信息的问题
        // let searchData = {};
        // let src = window.location.href
        // let index = src.indexOf("?");
        // let dataStr = src.substring(src.indexOf("?") + 1);
        // let dataArray = dataStr.split("&");
        // for (let i = 0; i < dataArray.length; i++) {
        //     let param = dataArray[i].split("=");
        //     searchData[param[0]] = param[1];
        // }
        // if(searchData.p && searchData.en){
        //   state.userInfo=""
        //   const userInfo = await loginUtil.autoLogin(searchData.p,searchData.en);
        //   if (userInfo) {
        //     state.userInfo = userInfo;
        //     window.localStorage.setItem('data', JSON.stringify(userInfo));
        //   }else{
        //     state.userInfo={id:-1}
        //   }
        // }else if (window.localStorage.getItem('data')) {
        //   console.log(123123)
        //   state.userInfo = JSON.parse(window.localStorage.getItem('data'));
        // }
        // if(window.location.search) {
        //   if (getUrlVars('p') && getUrlVars('en')) {
        //     const userInfo = await loginUtil.autoLogin(getUrlVars('p'), getUrlVars('en'));
        //     if (userInfo) {
        //       state.userInfo = userInfo;
        //       console.log(userInfo)
        //       window.localStorage.setItem('data', JSON.stringify(userInfo));
        //     }
        //   }
        // } else if (window.localStorage.getItem('data')) {
        //   state.userInfo = JSON.parse(window.localStorage.getItem('data'));
        // }
        if(Object.keys(state.saveMyUserInfo).length != 0){
          if(sessionStorage.saveMainAcountInfo){
            // 员工模式下刷新，获取自己的供应商信息和主账号的供应商信息
            let IdentityData = JSON.parse(sessionStorage.saveMainAcountInfo)
            state.identityMode = IdentityData.identityMode
            state.userInfo = IdentityData.staffUserInfo
            request.getSupplierInfo({
              uid: state.saveMyUserInfo.id
            }).then((res) => {
              state.saveMySupplierInfo=res
            })
            request.getSupplierInfo({
              uid: state.userInfo.id
            }).then((res) => {
              state.supplierInfo=res
            })
          }else{
            request.getSupplierInfo({
              uid: state.saveMyUserInfo.id
            }).then((res) => {
              state.supplierInfo=res
              state.saveMySupplierInfo = res
            })
          }
          request.getStaffHasMe(
            JSON.parse(localStorage.data).id
          ).then(res => {
            state.mainAcounts = res
          })
          // await this.$core({
          //    url:'/guigui/cloudStorage/getSupplierInfo',
          //    method:"POST",
          //    data:{
          //       uid:state.userInfo.id
          //    },
          //    success:res=>{
          //      console.log('供应商信息',res)
          //      state.supplierInfo=res.data
          //     //  console.log('gys',res.data)
          //    },
          // })
          // await this.$post("/guigui/cloudStorage/getSupplierInfo",{
          //   uid:state.userInfo.id
          // },res => {
          //   state.supplierInfo=res.data
          // })
        }
      },
      logout (state) {
        state.userInfo = {};
        window.localStorage.removeItem('data');
        window.sessionStorage.removeItem('saveMainAcountInfo');
        // window.location.search = '';
        // state.navNow = '云仓商城'
		console.log(location.host)
		let pageTo=encodeURIComponent("//"+location.host+'/index.html')
		  if(state.backendNav){
			pageTo=encodeURIComponent("//"+location.host+'/index.html#/personalCenter')
		  }
	  if(process.env.NODE_ENV=="development"){
	    location.href = 'http://localhost:8010/login.html?other=true&pageTo=' + pageTo
	  }else{
	    location.href='./login.html?pageTo='+pageTo
	  }
      },
      setClassFilter(state, data) {
        state.classFilter = data;
      },
      setBasicMaterialFilter(state, data) {
        state.basicMaterialFilter = data;
      },
      // 获取分类栏
      getColorTable(state, arr){
        state.classifyArr = arr
      },
    },
    actions: {
      // getBasicMaterialFilter(context, userInfo, supplierInfo) {
      //   getBasicMaterialList(userInfo, supplierInfo).then((res) => {
      //     context.commit('setBasicMaterialFilter', processingBasicMaterialFilter(res))
      //   });
      // }

    },
    modules: {
    }
  })
}
